import React, { Component } from "react";
import ProjectDetails from "./ProjectDetails";
import { Element } from "react-scroll";

const PROJECTS = [
  {
    img: "/images/igallery.png",
    title: "iGallery",
    link: "https://igallery-prod.herokuapp.com/",
    source: "https://github.com/zakali22/iGallery"
  },
  {
    img: "/images/business.PNG",
    title: "Business directory",
    link: "https://stormy-anchorage-77524.herokuapp.com/",
    source: "https://github.com/zakali22/BusinessDirectory"
  },
  {
    img: "/images/weather.jpg",
    title: "Weather web app",
    link: "https://afternoon-ridge-59283.herokuapp.com/",
    source: "https://github.com/zakali22/WeatherApp"
  },
  {
    img: "/images/todo.png",
    title: "Todo web app",
    link: "https://protected-peak-30704.herokuapp.com/",
    source: "https://github.com/zakali22/TodoApp"
  }
];

class ClientProjects extends Component {
  render() {
    return (
      <Element className="headline__side">
        <h1>Side projects</h1>
        <div className="headline__projects">
          {PROJECTS.map(project => {
            return <ProjectDetails details={project} />;
          })}
        </div>
      </Element>
    );
  }
}

export default ClientProjects;



// WEBPACK FOOTER //
// ./src/component/Projects/SideProjects.js